import loadable from "@loadable/component";

const lazy = loadable(() => import(/* webpackChunkName: "components-no-data-table" */ "."));

export default lazy;
